export enum RegistrationProcessTabId {
  verification = '',
  drafting = 'drafting',
  filing = 'filing',
}
